import { Component, OnInit } from '@angular/core';
import { ROUTES } from 'src/app/constants/Routes';


@Component({
  selector: 'app-vehicle-app-store',
  templateUrl: './vehicle-app-store.component.html',
  styleUrls: ['./vehicle-app-store.component.scss'],
  standalone: false
})
export class VehicleAppStoreComponent implements OnInit {
  Routes = ROUTES;
  activeSection = 'overview';

  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'features', label: 'Control Model', icon: 'bx-shield-quarter' },
    { id: 'categories', label: 'Value Proposition', icon: 'bx-category' },
    { id: 'developers', label: 'Strategic Outcome', icon: 'bx-trending-up' },
    { id: 'workflow', label: 'Workflow', icon: 'bx-git-branch' },
  ];

  workflowImage = 'assets/images/websitev2/workflow-diagrams/in-app-marketplace.png';

  overviewHighlights = [
    { val: 'OEM Native', label: 'Applications live inside the OEM IVI environment, not as a thin external-store dependency.' },
    { val: 'Governed', label: 'Approval, listing, update, and monetization policies stay under OEM control.' },
    { val: 'Monetizable', label: 'Post-sale digital commerce can scale across subscriptions, features, and partner services.' },
  ];

  features = [
    {
      icon: 'bx-devices',
      title: 'Native OEM App Environment',
      desc: 'Applications are designed for the OEM infotainment stack, allowing tighter UX control, policy enforcement, and deeper vehicle integration.',
    },
    {
      icon: 'bx-store-alt',
      title: 'Independent Distribution Model',
      desc: 'The marketplace operates independently of external consumer app stores so availability, certification, and release timing stay OEM-defined.',
    },
    {
      icon: 'bx-wallet',
      title: 'OEM-Defined Monetization',
      desc: 'Revenue models can be structured around subscriptions, paid upgrades, bundles, or partner-led services without surrendering ownership.',
    },
    {
      icon: 'bx-refresh',
      title: 'OTA-Led App Lifecycle',
      desc: 'Updates are delivered through OEM-controlled OTA channels, enabling rapid rollout, patching, and retirement of services across the fleet.',
    },
    {
      icon: 'bx-line-chart',
      title: 'Data and Usage Ownership',
      desc: 'Usage analytics, engagement signals, and service insights remain within the OEM ecosystem to support product and business decisions.',
    },
    {
      icon: 'bx-check-shield',
      title: 'Governed Ecosystem Control',
      desc: 'Partner participation, catalog structure, approval workflows, and compliance rules can be managed centrally for each program or region.',
    },
  ];

  categories = [
    {
      icon: 'bx-crown',
      name: 'Digital Ownership',
      count: 'Control app lifecycle, availability, pricing, and data without external platform dependency.',
    },
    {
      icon: 'bx-rocket',
      name: 'Faster Innovation',
      count: 'Launch, update, and retire services faster than traditional vehicle release cycles allow.',
    },
    {
      icon: 'bx-coin-stack',
      name: 'New Revenue Streams',
      count: 'Create post-sale monetization across premium apps, features, subscriptions, and partner integrations.',
    },
    {
      icon: 'bx-palette',
      name: 'Consistent Brand Experience',
      count: 'Ensure every service aligns with OEM UX standards, trust posture, and in-vehicle design language.',
    },
    {
      icon: 'bx-git-branch',
      name: 'Scalable Ecosystem Model',
      count: 'Support multiple partners, regions, and vehicle programs from one governed marketplace layer.',
    },
    {
      icon: 'bx-globe',
      name: 'Program Flexibility',
      count: 'Adapt catalog, policy, and commercial models across geographies and different product tiers.',
    },
  ];

  devSteps = [
    {
      step: '01',
      title: 'From Vehicle Delivery to Software Platform',
      desc: 'OEMs can extend the vehicle experience after sale by continuously introducing services, updates, and partner offerings through the marketplace.',
    },
    {
      step: '02',
      title: 'Long-Term Customer Engagement',
      desc: 'A governed app layer keeps users connected to new functionality, premium experiences, and brand-led digital journeys across ownership life cycles.',
    },
    {
      step: '03',
      title: 'Differentiation Through Services',
      desc: 'OEMs can create competitive distinction by controlling exactly which in-vehicle services are offered, how they perform, and how they evolve.',
    },
    {
      step: '04',
      title: 'Revenue Growth with Control',
      desc: 'Digital business models can grow without sacrificing platform governance, data ownership, or consistency of the in-vehicle brand experience.',
    },
  ];

  ngOnInit() {}


  scrollTo(id: string) {
    this.activeSection = id;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
